<template>
  <div class="nq5c-zt">
    <div class="fullPage" id="page" ref="fullPage">
      <div id="fullPageContainer" class="fullPageContainer" ref="fullPageContainer">
        <Kv />
        <div v-if="isPortrait">
          <MobPage :category="primaryCategories[0]" :bgImg="mob_bg_part1" :index="0" :itemList="mob_itemList_part1" :bigImgLink="bigImgLink1" :big-color="'#000'"/>
          <MobPage :category="primaryCategories[1]" :bgImg="mob_bg_part2" :index="1" :itemList="mob_itemList_part2" :bigImgLink="bigImgLink2" :big-color="'#fff'"/>
          <MobPage :category="primaryCategories[2]" :bgImg="mob_bg_part3" :index="2" :itemList="mob_itemList_part3" :bigImgLink="bigImgLink3" />
          <MobPage :category="primaryCategories[3]" :bgImg="mob_bg_part4" :index="3" :itemList="mob_itemList_part4" :bigImgLink="bigImgLink4" />
          <MobPage :category="primaryCategories[4]" :bgImg="mob_bg_part5" :index="4" :itemList="mob_itemList_part5" :bigImgLink="bigImgLink5" />
          <MobPage :category="primaryCategories[5]" :bgImg="mob_bg_part6" :index="5" :itemList="mob_itemList_part6" :bigImgLink="bigImgLink6" :big-color="'#fff'" :color="'#fff'"/>
        </div>
        <div v-else>
          <PcPageRight :category="primaryCategories[0]" :bgImg="pc_bg_part1" :big-color="'#000'" />
          <PcPageLeft :category="primaryCategories[1]" :bgImg="pc_bg_part2"  :big-color="'#000'"/>
          <PcPageRight :category="primaryCategories[2]" :bgImg="pc_bg_part3" />
          <PcPageLeft :category="primaryCategories[3]" :bgImg="pc_bg_part4"  :big-color="'#fff'"/>
          <PcPageRight :category="primaryCategories[4]" :bgImg="pc_bg_part5" />
          <PcPageLeft :category="primaryCategories[5]" :bgImg="pc_bg_part6" :big-color="'#fff'" :color="'#fff'"/>
        </div>
        <Last />
      </div>
    </div>
  </div>
</template>
<script>
import Kv from "@/components/aw2025/kv";
import Last from "@/components/aw2025/last";
import PcPageLeft from "@/components/aw2025/pc-page-left-1";
import PcPageRight from "@/components/aw2025/pc-page-right-1";
import MobPage from "@/components/aw2025/mob-page-1";
import { isPortraitFun } from "@/utils/utils.js";
import lazyLoad from "@/utils/lazyLoad.js";
import { queUrl } from "@/config/base";

export default {
  name: 'index',
  components: { Kv, PcPageLeft, PcPageRight, MobPage, Last },
  directives: {
    lazy: lazyLoad
  },
  created() {
    this.initPreText();
    this.fetchPrimaryCategories();
  },
  mounted() {
    // 清理所有历史 mall tabs 缓存
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith("mall_tabs_")) {
        sessionStorage.removeItem(key);
      }
    }
  },
  data() {
    return {
      isPortrait: isPortraitFun(),
      flag: false,
      preText: "https://www.kia.cn",
      // 一级分类数据（用于 PC 六屏）
      primaryCategories: [],
      //pc 商品部分背景图片
      pc_bg_part1: '/assets/~/media/images/activity/kiamall/pc/bg-1.jpg',
      pc_bg_part2: '/assets/~/media/images/activity/kiamall/pc/bg-2.jpg',
      pc_bg_part3: '/assets/~/media/images/activity/kiamall/pc/bg-3.jpg',
      pc_bg_part4: '/assets/~/media/images/activity/kiamall/pc/bg-4.jpg',
      pc_bg_part5: '/assets/~/media/images/activity/kiamall/pc/bg-5.jpg',
      pc_bg_part6: '/assets/~/media/images/activity/kiamall/pc/bg-6.jpg',
      //mob 商品部分背景图片
      mob_bg_part1: '/assets/~/media/images/activity/kiamall/mob/bg-01.jpg',
      mob_bg_part2: '/assets/~/media/images/activity/kiamall/mob/bg-02.jpg',
      mob_bg_part3: '/assets/~/media/images/activity/kiamall/mob/bg-03.jpg',
      mob_bg_part4: '/assets/~/media/images/activity/kiamall/mob/bg-04.jpg',
      mob_bg_part5: '/assets/~/media/images/activity/kiamall/mob/bg-05.jpg',
      mob_bg_part6: '/assets/~/media/images/activity/kiamall/mob/bg-06.jpg',
      //mob大图链接
      bigImgLink1: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1936&id=1805&type=&activityId=',
      bigImgLink2: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1650&id=1587&type=&activityId=',
      bigImgLink3: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1778&id=1689&type=&activityId=',
      bigImgLink4: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1722&id=1644&type=&activityId=',
      bigImgLink5: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1918&id=1787&type=&activityId=',
      bigImgLink6: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1797&id=1707&type=&activityId=',
      //mob 商品部分商品列表
      //*****************************part1**********************************
      mob_itemList_part1: [//right-part
        {
          img_item: '/assets/~/media/images/activity/kiamall/part1/item-1-2-mob.jpg',//mobd的不同一张
          title: 'Kia&ITO 城市皮质背包',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1929&id=1798&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part1/item-2-1.jpg',
          title: 'Kia定制反向折叠伞',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1934&id=1803&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part1/item-2-2.jpg',
          title: 'Kia定制弹弹直饮杯',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1935&id=1804&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part1/item-2-3.jpg',
          title: 'Kia&ITO 旅行箱',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1931&id=1800&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part1/item-2-4.jpg',
          title: 'Kia&几素 手持小风炮风扇',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1932&id=1801&type=&activityId=',
        },
      ],
      //*****************************part2**********************************
      mob_itemList_part2: [//left-part
        {
          img_item: '/assets/~/media/images/activity/kiamall/part2/item-1-1-mob.jpg',//mobd的不同一张
          title: '飞利浦足浴按摩器',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1913&id=1783&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part2/item-2-1.jpg',
          title: '资生堂蓝胖子防晒霜',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1417&id=1381&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part2/item-2-2.jpg',
          title: 'BRUNO拎拎保温杯',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=2050&id=1895&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part2/item-2-3.jpg',
          title: '蕉下保暖口罩',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1997&id=1855&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part2/item-2-4.jpg',
          title: '摩飞围炉煮茶器',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=2084&id=1920&type=&activityId=',
        },
      ],
      //*****************************part3**********************************
      mob_itemList_part3: [//right-part
        {
          img_item: '/assets/~/media/images/activity/kiamall/part3/item-1-2-mob.jpg',//mobd的不同一张
          title: 'WEDGWOOD吸管杯',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1609&id=1556&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part3/item-2-1.jpg',
          title: '摩飞便携原汁机',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=2082&id=1919&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part3/item-2-2.jpg',
          title: '小罐茶银罐系列茶',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1922&id=1791&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part3/item-2-3.jpg',
          title: '重力星球机械充电头',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=2076&id=1915&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part3/item-2-4.jpg',
          title: '美的小型制冰机',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1874&id=1751&type=&activityId=',
        },
      ],
      //*****************************part4**********************************
      mob_itemList_part4: [//left-part
        {
          img_item: '/assets/~/media/images/activity/kiamall/part4/item-1-1-mob.jpg',//mobd的不同一张
          title: '微果云台投影仪',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1526&id=1478&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part4/item-2-1.jpg',
          title: '天梭洛克系列机械表',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1557&id=1504&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part4/item-2-2.jpg',
          title: 'CICIDO头枕腰靠套装',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=2003&id=1858&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part4/item-2-3.jpg',
          title: '塞那耳夹蓝牙耳机',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1804&id=1713&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part4/item-2-4.jpg',
          title: '美旅车载充电器',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1391&id=1363&type=&activityId=',
        },
      ],
      //*****************************part5**********************************
      mob_itemList_part5: [//right-part
        {
          img_item: '/assets/~/media/images/activity/kiamall/part5/item-1-2-mob.jpg',//mobd的不同一张
          title: 'usmile电动牙刷',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1766&id=1683&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part5/item-2-1.jpg',
          title: '匹克运动双肩包',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1611&id=1557&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part5/item-2-2.jpg',
          title: '牧高笛户外酒精炉',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1879&id=1754&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part5/item-2-3.jpg',
          title: 'SKG颈椎按摩器',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1265&id=1237&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part5/item-2-4.jpg',
          title: '探险者户外套装',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1909&id=1780&type=&activityId=',
        },
      ],
      //*****************************part6**********************************
      mob_itemList_part6: [//left-part
        {
          img_item: '/assets/~/media/images/activity/kiamall/part6/item-1-1-mob.jpg',//mobd的不同一张
          title: '喜马拉雅巅峰会员卡',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1793&id=1703&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part6/item-2-1.jpg',
          title: '芒果PC移动会员卡',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1790&id=1700&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part6/item-2-2.jpg',
          title: '网易云音源会员卡',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1794&id=1704&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part6/item-2-3.jpg',
          title: '爱奇艺黄金会员卡',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1792&id=1702&type=&activityId=',
        },
        {
          img_item: '/assets/~/media/images/activity/kiamall/part6/item-2-4.jpg',
          title: '哔哩哔哩超级大会员卡',
          link: 'https://app-web.kia.cn/kia_wap/#/pages/store/view/view?skuId=1129&id=1101&type=&activityId=',
        },
      ],
    };
  },
  methods: {
    getMallTabStorageKey(scope) {
      const safeScope = scope || "default";
      return `mall_tabs_${safeScope}`;
    },
    forbid() {
      this.flag = true;
    },
    open() {
      this.flag = false;
    },
    initPreText() {
      const href = window.location.href || "";
      if (href.includes("uat.kia.cn")) {
        this.preText = "https://uat.kia.cn";
      } else if (href.includes("www.kia.cn")) {
        this.preText = "https://www.kia.cn";
      } else {
        // 本地/测试环境
        this.preText = "https://uat.kia.cn";
      }
    },
    async fetchPrimaryCategories() {
      try {
        const res = await this.$axios({
          method: "get",
          url: `${queUrl}api/shop/product/api/primaryList`,
        });
        const data = res && res.data ? res.data : res;
        // 兼容不同返回结构：优先 data，其次 rows
        const list = (data && (data.data || data.rows)) || [];
        if (Array.isArray(list)) {
          this.primaryCategories = list;
        } else {
          this.primaryCategories = [];
        }
      } catch (e) {
        console.warn("[AW2025] primaryList error:", e);
      }
    },
  }
}

</script>

<style lang="scss" scoped>
.fullPage {
  padding: 0;
  margin: 0;
  color: #000000;
}

.fullPageContainer {
  width: 100%;
  transition: all ease-out 0.8s;
}

.section {
  width: 100%;
  @media (max-width:767px) {
    height: calc(2236 / 1125 * 100vw);
  }
  background-position: center center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.section6 {
  height: auto;
}
</style>
